import { render, staticRenderFns } from "./contactsInput.vue?vue&type=template&id=d2733b12&scoped=true&"
import script from "./contactsInput.vue?vue&type=script&lang=ts&"
export * from "./contactsInput.vue?vue&type=script&lang=ts&"
import style0 from "./contactsInput.vue?vue&type=style&index=0&id=d2733b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2733b12",
  null
  
)

export default component.exports